import { render, staticRenderFns } from "./UscitaPiatti.vue?vue&type=template&id=5aebbcdc&"
import script from "./UscitaPiatti.vue?vue&type=script&lang=js&"
export * from "./UscitaPiatti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports